import { useTheme } from '@mui/styles';

export const useIdCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    text: {
      paddingTop: theme.spacing(1.25),
    },
  };
};
